import type { Partners } from 'src/types';

export const partners: Partners = {
  label: 'International partners',
  links: [
    {
      title: 'Bdjobs (Bangladesh)',
      url: 'https://bdjobs.com/',
    },
    {
      title: 'Jobsdb (S.E. Asia)',
      url: 'https://www.jobsdb.com/',
    },
    {
      title: 'Jobstreet (S.E. Asia)',
      url: 'https://www.jobstreet.com/',
    },
    {
      title: 'Jora (Worldwide)',
      url: 'https://www.jora.com/',
    },
    {
      title: 'Seaman Jobsite (Philippines)',
      url: 'https://seamanjobsite.workabroad.ph/',
    },
    {
      title: 'Work Abroad (Philippines)',
      url: 'https://www.workabroad.ph/',
    },
    {
      title: 'Workana (Latin America)',
      url: 'https://www.workana.com/',
    },
  ],
};
